import { createSelector } from '@ngrx/store';
import { IRootState } from '../../../root';
import { ICreditAgreementState } from './credit-agreement.state';

export class CreditAgreementSelectors {
  // todo: replace any type state with root state (once defined)
  static readonly creditAgreementState = (state: IRootState): ICreditAgreementState => {
    return state.creditAgreement as ICreditAgreementState;
  };

  static readonly model = createSelector(
    CreditAgreementSelectors.creditAgreementState,
    (creditAgreement: ICreditAgreementState) => {
      return creditAgreement.model;
    }
  );

  static readonly data = createSelector(
    CreditAgreementSelectors.creditAgreementState,
    (creditAgreement: ICreditAgreementState) => {
      return creditAgreement.data;
    }
  );
}
